import { Box, Grid, GridItem, HTMLChakraProps } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { ProfileInfoSkeleton } from '@/components/ui/shared/profile/ProfileInfo/ProfileInfo';
import { ProfileList } from '@/components/ui/shared/profile/ProfilesList/ProfileList';
import { queryAllLectureProfilesByLectureId } from '@/fetchers/lectureProfiles';
import { useResources } from '@/lib/datx-jsonapi-react';

export const LectureSpeakers: FC<HTMLChakraProps<'div'>> = (props) => {
  const { t } = useTranslation();

  const { id } = useLecturePageQueryParams();

  const { data: lectureProfiles, error } = useResources(queryAllLectureProfilesByLectureId(id));

  const profiles = lectureProfiles
    ?.filter((lectureProfile) => lectureProfile.type === 'speaker')
    .map((lectureProfile) => lectureProfile?.profile);

  return (
    <Box {...props}>
      {!lectureProfiles && !error && (
        <Grid
          mt={[0, null, 8]}
          gap={10}
          templateColumns={['repeat(1, 1fr)', null, 'repeat(2, 1fr)']}
          alignItems="center"
          pr={8}
        >
          <GridItem>
            <ProfileInfoSkeleton />
          </GridItem>
          <GridItem>
            <ProfileInfoSkeleton />
          </GridItem>
        </Grid>
      )}
      {profiles?.length ? <ProfileList title={t('newLecture.speakersTitle')} profiles={profiles} /> : null}
    </Box>
  );
};
